import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LazyRenderDirective } from './lazy-render.directive';

@NgModule({
  declarations: [
    LazyRenderDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    LazyRenderDirective
  ]
})
export class LazyRenderModule { }
